<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />
    <div v-if="!isAuditor" class="developer-organization-name">
      <span class="name">切换技术服务商：</span>
      <el-select
        v-model="developerOrganizationId"
        placeholder="请选择"
        filterable
        @change="onChangeTechnicalServiceProvider"
      >
        <el-option v-for="item in technicalServiceProviderList" :key="item.id" :label="item.organizationName" :value="item.id">
          <span>{{ item.organizationName }}</span>
          <el-tag v-if="item.status === -1" type="danger" style="position: absolute; right: 20px">已失效</el-tag>
        </el-option>
      </el-select>
    </div>

    <div class="right-menu">
      <template v-if="device !== 'mobile'">
        <!--        <search id="header-search" class="right-menu-item" />-->

        <error-log class="errLog-container right-menu-item hover-effect" />

        <screenfull id="screenfull" class="right-menu-item hover-effect" />
        <!--
        <el-tooltip content="Global Size" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip>-->
      </template>

      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
        @command="handleCommand"
      >
        <div class="avatar-wrapper">
          <el-image
            ref="img"
            :src="avatar"
            class="user-avatar"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-user" />
            </div>
          </el-image>
          <!--          <svg-icon icon-class="user" />-->
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link v-if="!isAuditor" to="/token-manager/index">
            <el-dropdown-item>个人中心</el-dropdown-item>
          </router-link>
          <el-dropdown-item v-if="!isAuditor" divided command="switchDeveloper">
            切换技术服务商
          </el-dropdown-item>
          <el-dropdown-item divided command="logout">
            退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-tag
        v-if="loginUserName"
        size="small"
        effect="dark"
      >
        {{ loginUserName }}
      </el-tag>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import ErrorLog from '@/components/ErrorLog'
import Screenfull from '@/components/Screenfull'
import { getDeveloperOrganization } from '@/api/applet-store'
import db from '@/utils/localstorage'

export default {
  components: {
    Breadcrumb,
    Hamburger,
    ErrorLog,
    Screenfull
  },
  data() {
    return {
      technicalServiceProviderList: [], // 技术服务商列表
      developerOrganizationId: null,
      loginUserName: ''
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'device']),
    ...mapState({
      roles: (state) => state.account.user.roles
    }),
    isAuditor() {
      return this.roles.includes('developer_auditor')
    }
  },
  mounted() {
    if (!this.isAuditor) {
      this.getTechnicalServiceProviderList()
    }
    this.developerOrganizationId = parseInt(localStorage.getItem('developerOrganizationId')) || null
    this.loginUserName = localStorage.getItem('loginUserName') || JSON.parse(localStorage.getItem('USER')).username

    // 监听storage变化
    this.$bus.$on('developerOrganizationIdUpdated', this.handleDeveloperOrganizationIdUpdate)
    this.$bus.$on('loginUserNameUpdated', this.handleLoginUserNameUpdated)
  },
  beforeDestroy() {
    // 清理事件监听
    this.$bus.$off('developerOrganizationIdUpdated', this.handleDeveloperOrganizationIdUpdate)
    this.$bus.$off('loginUserNameUpdated', this.handleLoginUserNameUpdated)
  },
  methods: {
    handleCommand(command) {
      if (command === 'switchDeveloper') {
        this.switchDeveloper()
      } else if (command === 'logout') {
        this.logout()
      }
    },
    handleDeveloperOrganizationIdUpdate(data) {
      if (data.key === 'developerOrganizationId') {
        this.developerOrganizationId = parseInt(data.newValue)
        this.$forceUpdate() // 强制更新视图
      }
    },
    handleLoginUserNameUpdated(data) {
      if (data.key === 'loginUserName') {
        this.loginUserName = data.newValue
        this.$forceUpdate() // 强制更新视图
      }
    },
    // 切换技术服务商
    onChangeTechnicalServiceProvider() {
      this.removeHomeStatus()
      localStorage.setItem('developerOrganizationId', this.developerOrganizationId)
      const jwt = require('jsonwebtoken')
      const token = db.get('ACCESS_TOKEN')
      const loginUserName = jwt.decode(token, { complete: true }).payload.preferred_username
      const creatorName = this.technicalServiceProviderList.find(item => item.id === this.developerOrganizationId).createdBy
      const organizationName = this.technicalServiceProviderList.find(item => item.id === this.developerOrganizationId).organizationName
      localStorage.setItem('loginUserName', loginUserName)
      localStorage.setItem('developerOrganizationCreatorName', creatorName)
      localStorage.setItem('developerOrganizationName', organizationName)
      const currentSelectOrganization = this.technicalServiceProviderList.find(item => item.id === this.developerOrganizationId)
      localStorage.setItem('minWeight', currentSelectOrganization.minWeight)
      this.$router.go(0)
    },
    // 获取技术服务商列表
    getTechnicalServiceProviderList() {
      getDeveloperOrganization().then((res) => {
        this.technicalServiceProviderList = res
      })
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    switchDeveloper() {
      localStorage.removeItem('developerOrganizationId')
      this.$router.go(0)
    },
    removeHomeStatus() {
      sessionStorage.removeItem('HOME_ACTIVE_MENU_ID')
      sessionStorage.removeItem('HOME_APP_LIST_STATE')
    },
    async logout() {
      // await this.$store.dispatch('user/logout')
      this.removeHomeStatus()
      await this.$store.dispatch('account/keycloakLogout')
      // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  // background: #fff;
  // box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  color: #fff;

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .developer-organization-name {
    display: flex;
    align-items: center;
    position: absolute;
    height: 100%;
    margin-left: 30%;
    .name {
      font-size: 16px;
    }
    .el-select {
      ::v-deep .el-input__inner {
        font-size: 18px;
        background: #3569FD;
        color: #fff;
        border-radius: 20px !important;
      }

      ::v-deep .el-select__caret {
        font-size: 18px;
      }
    }
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    display: flex;
    align-items: center;
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      // color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 10px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 32px;
          height: 32px;
          border-radius: 50%;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 12px;
          font-size: 12px;
          color: #fff;
        }
      }
    }
  }
  .image-slot{
    i{
      color: #fff;
      position: absolute;
      top: 8px;
      left: 10px;
    }
  }
}
</style>
